// Получение шапки по идентификатору
let header = $('.worldwide-header');

if (header.length > 0) {

    /*
     Генерация прозрачного блока высотой с шапку и постановка его в отмеченные блоки страницы
     (особенно актуально для блоков с собственным фоном, чтобы фон попадал под шапку)
     */
    let markedBlocks = $(document).find('.worldwide-header-offset');
    let ghost = $('<div/>', {
        css: {
            height: header.height(),
            transition: '0.25s ease-in-out height',
        }
    }).prependTo(markedBlocks);

    // При прокручивании страницы
    $(document).scroll(function () {

        /*
         Если отступ шапки от верхнего края документа больше половины размера шапки, то свернуть ее.
         В противном случае развернуть.
         */
        if (header.offset().top > (header.height() / 2)) {
            header.addClass('collapsed');
        } else {
            header.removeClass('collapsed');
        }

    });

    /*
     При смене размеров окна переопределять высоту призрака
     (на мобильных шапка меньше по высоте)
     */
    $(window).resize(function() {
        ghost.css('height', header.height());
    });

}